import React, { useRef, useEffect, useState } from "react";

function CustomStepper({activeStep,stepsData}) {
  const steps = stepsData


  const [dividerWidth, setDividerWidth] = useState("auto");
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const numDividers = steps.length - 1;
      const stepWidth = 105; // Assuming each step icon container is 35px wide
      const padding = 30 * 2; // Total padding (left + right)
      const calculatedWidth = `${
        (containerWidth - padding - stepWidth * steps.length) / numDividers
      }px`;
      setDividerWidth(calculatedWidth);
    }
  }, [steps.length]);

  const stepColor = (index) => {
    const stepsNumber = index+1
    if (stepsNumber < activeStep) return "#4CAF50";
    if (stepsNumber === activeStep) return "rgb(18, 72, 135)";
    return "lightgray";
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      ref={containerRef}
      style={{ paddingLeft: "30px", paddingRight: "30px" }}
    >
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          {index !== 0 && (
            <div
              style={{
                height: "3px",
                backgroundColor: index < activeStep ? stepColor(index - 1) : "lightgray",
                width: dividerWidth,
              }}
            ></div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: index === activeStep ? "white" : "transparent",
                borderRadius: "4px",
                border: `2px solid ${stepColor(index)}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: index === activeStep ? "rgb(18, 72, 135)" : "lightgray",
              }}
            >
              <i
                className="material-icons"
                style={{
                  color: stepColor(index)             
                }}
              >
                {step.icons}
              </i>
            </div>
            {/* Optionally, you can add a label under the icon */}
            <span style={{ color: stepColor(index), fontWeight: '600', marginTop: '4px' }}>
              {step.h}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default CustomStepper;
